import { render, staticRenderFns } from "./BasedOnAplication.vue?vue&type=template&id=0a54fc64&"
import script from "./BasedOnAplication.vue?vue&type=script&lang=js&"
export * from "./BasedOnAplication.vue?vue&type=script&lang=js&"
import style0 from "./BasedOnAplication.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports